import { useCallback, useEffect, useState, forwardRef } from 'react'
import { getVideo } from '../../s3Func/s3Download'

import Lottie from 'react-lottie'

const LottieAnimation = forwardRef(({ jsonUrl, onAnimationComplete, speed, unit1, login }, ref) => {
	const [animation, setAnimation] = useState({})

	const getConfiguration = useCallback(async () => {
		const config = await getVideo(jsonUrl, login)
		let data = await fetch(config)
		data = await data.json()

		const defaultAnimation = {
			loop: false,
			autoplay: false,
			animationData: {},
			rendererSettings: {
				preserveAspectRatio: 'xMidYMid slice',
			},
		}

		defaultAnimation.animationData = data

		setAnimation(defaultAnimation)
	}, [jsonUrl])

	useEffect(() => {
		getConfiguration()
	}, [getConfiguration])

	return (
		<div>
			{animation.animationData && (
				unit1 ?
				<Lottie
					ref={ref}
					options={animation}
					height={380}
					width={300}
					speed={speed ? speed : 1}
					// eventListeners={[
					// 	{
					// 		eventName: 'complete',
					// 		callback: onAnimationComplete,
					// 	},
					// ]}
				/>
				:
				<Lottie
					ref={ref}
					options={animation}
					speed={speed ? speed : 1}
					// eventListeners={[
					// 	{
					// 		eventName: 'complete',
					// 		callback: onAnimationComplete,
					// 	},
					// ]}
				/>
			)}
		</div>
	)
})

export default LottieAnimation
